import { openPopup } from "../../../components/Popups/Popup.reducer";
import { EnumPopupType } from "../../../components/Popups/Popup.enum";
import { PopupProps } from "../../../components/Popups/PopupProps.types";
import store from "../../../core/store/index";
import { all, takeEvery, put, call } from "@redux-saga/core/effects";

import { DOWNLOAD_STANDARD_QUESTION_TEMPLATE } from "./StandardQuestionTemplate.actions";
import { AnyAction } from "redux";
import { standardQuestionTemplateReducerActions } from "./StandardQuestionTemplate.reducer";
import { StandardDTO } from "../../../common/types/common.dto.types";
import dayjs from "dayjs";
import { StandardQuestionTemplateType } from "./StandardQuestionTemplate.types";

const excelWorkerStandardQuestionTemplate: Worker = new Worker(
  new URL("./ExcelWorkerStandardQuestionTemplate.ts", import.meta.url)
);

excelWorkerStandardQuestionTemplate.onmessage = (event) => {
  const excelData = event.data.buffer;

  //Handle the Excel data here, for example, you can save it as a file
  const blob = new Blob([excelData], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });
  const url = window.URL.createObjectURL(blob);
  let downloadFileName = `${event.data.name}`;
  const extension = getFileExtensionFromMimeType(blob.type);
  if (extension != null && extension != "") {
    if (!downloadFileName.endsWith(extension)) {
      downloadFileName += extension;
    }
  }
  // Create a download link for the Excel file and trigger the download
  const a = document.createElement("a");
  a.href = url;
  a.download = downloadFileName;
  a.click();

  window.URL.revokeObjectURL(url);
  store.dispatch(
    standardQuestionTemplateReducerActions.setStandardQuestionTemplateStatus(
      false
    )
  );

  store.dispatch(
    openPopup({
      Open: true,
      BodyText: "Standard question template downloaded successfully",
      HeaderText: "Success", //"Success",
      PopupType: EnumPopupType.SuccessPopup,
    } as PopupProps)
  );

  return () => {
    excelWorkerStandardQuestionTemplate.terminate();
  };
};

const downloadStandardQuestionTemplateWatcher = function* (): any {
  yield takeEvery(
    DOWNLOAD_STANDARD_QUESTION_TEMPLATE,
    function* (action: AnyAction): any {
      const standardData = action.payload as StandardDTO;

      yield put(
        standardQuestionTemplateReducerActions.setStandardQuestionTemplateData({
          StandardId: standardData.Id,
          StandardName: standardData.Name,
          IsDownloading: true,
        } as StandardQuestionTemplateType)
      );

      try {
        const workerObj = {
          data: standardData.Name,
          name: `Standard - Bulk Upload Questions Template`,
        };

        excelWorkerStandardQuestionTemplate.postMessage(workerObj);
      } catch {
        yield put(
          openPopup({
            Open: true,
            BodyText:
              "Sorry, An error occured while generating the excel template!",
            HeaderText: "Warning",
            PopupType: EnumPopupType.WarningPopup,
            OkBtnClick() {},
          } as PopupProps)
        );
      }
    }
  );
};

const getFileExtensionFromMimeType = (mimeType) => {
  const mimeTypesToExtensions = {
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet":
      ".xlsx",
    "application/msword": ".doc",
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document":
      ".docx",
    "application/pdf": ".pdf",
    "image/jpeg": ".jpg",
    "image/png": ".png",
  };
  return mimeTypesToExtensions[mimeType] || "";
};

const standardQuestionTemplateSaga = function* () {
  yield all([downloadStandardQuestionTemplateWatcher()]);
};
export default standardQuestionTemplateSaga;
